import React from "react";
import * as ReactDOM from "react-dom";
import {PopupManager, GlobalPopupManager} from './PopupManager';

const popUpContainer = document.createElement("div");
var Popup, tmpGlobalPopup;
document.body.appendChild(popUpContainer);
ReactDOM.render(<div>
<GlobalPopupManager 
  ref={(input) => {
    tmpGlobalPopup = input;
  }} 
/>
<PopupManager 
  ref={(input) => {
    Popup = input;
  }} 
/>

</div>, popUpContainer);


export const GlobalPopup = tmpGlobalPopup;

console.log("Popup", Popup);
export default Popup;
 


// WEBPACK FOOTER //
// ./src/components/Popup.js